import { Images } from '@/assets/imgs';
import { BtnDark } from '@/components/Buttons';
import { ObserverContainer } from '@/components/ObserverContainer';
import { splitLines } from '@/modules/utils/utils';
import Image from 'next/image';
import Link from 'next/link';
import { useEffect, useRef, useState } from 'react';
import { Timeline, Tween } from 'react-gsap';
import { Scene } from 'react-scrollmagic';

export const EliteBenefits = () => {
  const ref = useRef<HTMLHeadingElement>(null);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (ref.current) {
      splitLines(ref.current);
    }
  }, []);

  return (
    <div className="prometheus-elite-benefits">
      <div className="container">
        <ObserverContainer className="flex column">
          <h2 className="integralfc-h2 reveal-from-bottom" ref={ref}>
            ELITE BENEFITS
          </h2>
        </ObserverContainer>

        <div className={`flex flex-wrap cols ${loading ? 'out' : 'in'}`}>
          <ObserverContainer
            className="block-container first"
            onAnimateIn={() => setLoading(false)}
            onAnimateOut={() => setLoading(true)}
          >
            <div className="block">
              <div className="lexend-heading-l">Early Ecosystem Governance</div>
              <p className="lexend-body-md l">
                Take part in shaping the development of the XBorg ecosystem by
                issuing or voting on proposals.
              </p>
              <Link
                href="https://snapshot.org/#/xborg.eth"
                target="_blank"
                className="flex middle lexend-body-md sb link"
              >
                View Governance
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M15.7 11.6758L9.70005 17.6758L8.30005 16.2758L12.9 11.6758L8.30005 7.07578L9.70005 5.67578L15.7 11.6758Z"
                    fill="#EB3A4A"
                  />
                </svg>
              </Link>
            </div>
          </ObserverContainer>
          <div className="block-container">
            <div className="flex colummn block-content">
              <div className="block expand">
                <div className="lexend-heading-l">Prometheus Tier Status</div>
                <p className="lexend-body-md l">
                  Enjoy the best opportunities, prices and allocations with the
                  highest tier in the XBorg ecosystem.
                </p>
              </div>
            </div>
          </div>
          <div className="block-container third">
            <div className="block">
              <div className="lexend-heading-l">Early and Feeless Access</div>{' '}
              <p className="lexend-body-md l">
                Prometheans get early and feeless access to all XBorg platforms,
                products and technology.
              </p>
            </div>
          </div>
          <div className="block-container"></div>
          <div className="block-container fourth">
            <div className="block">
              <div className="lexend-heading-l">XBG Token Benefits</div>
              <p className="lexend-body-md l">
                Receive an XBG airdrop at our Token Generation Event and receive
                the best staking yield.
              </p>

              <Image
                src={Images.prometheusNFT.discord}
                alt="discord"
                quality={100}
                width={90}
                height={90}
              />
            </div>
          </div>
        </div>
      </div>

      <Scene duration="200%" triggerHook="onEnter">
        <Tween
          position="0"
          from={{
            y: 0,
          }}
          to={{
            y: 350,
          }}
        >
          <div className="parallax-bubble-2">
            <Image src={Images.landing.sphere} alt="" width={39} height={39} />
          </div>
        </Tween>
      </Scene>

      <Scene duration="100%" triggerHook="onEnter">
        <Tween
          position="0"
          from={{
            y: 0,
          }}
          to={{
            y: 150,
          }}
        >
          <Image
            src={Images.landing.bubbles_bot_right}
            width={1062}
            height={883}
            alt=""
            className="background"
          />
        </Tween>
      </Scene>
    </div>
  );
};
